export default "__VITE_ASSET__CIuZshw9__"